module.exports = __webpack_public_path__ + "static/maddepally-5b93647d8cd3cd03cefd021be92d667d.jpg";